<template>
    <kimsa-confirm
        ref="cancelModal"
        :title="$t('payment.cancel_subscription')"
        :content="bodyMessage"
        :loading="loadingSubscribeCancel"
        :persistent="false"
        @confirm="confirmSubscriptionCancel"
        :close-on-confirm="false"
        :alert-mode="true"
    ></kimsa-confirm>
</template>

<script>
import firebase from '@/utils/Firebase'
import KimsaConfirm from "@/components/common/KimsaConfirm";

export default {
    components: {KimsaConfirm},
    data() {
        return {
            loadingSubscribeCancel: false,
        }
    },
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },
    computed: {
        isStudent(vm = this) {
            return vm.account?.accountType === 'student'
        },
        bodyMessage() {
            const vm = this

            let name = vm.subscription.coachName ?
                vm.$t('payment.cancel_subscription_with_name', {coach: vm.subscription.coachName}) :
                vm.$t('payment.cancel_subscription_without_name')

            let message = vm.$t('payment.cancel_subscription_content', {subscription: name})

            if (!vm.isStudent && vm.account?.stripeAccount?.trialEnded) return `<b>${vm.$t('coach.yet_free_days')}</b> ${message}`
            return message
        },
        httpsCallableMethod(vm = this) {
            return vm.isStudent ?
                'httpPayments-cancelSubscription' :
                'httpPayments-cancelSubscriptionCoach'
        }
    },
    methods: {
        show() {
            const vm = this
            vm.$refs.cancelModal.show()
        },
        async confirmSubscriptionCancel() {
            const vm = this
            if (!vm.subscription) return

            vm.loadingSubscribeCancel = true
            const payload = {subscriptionUID: vm.subscription.id}
            let cancelSubscription = firebase.functions().httpsCallable(vm.httpsCallableMethod)
            await cancelSubscription(payload).catch(err => {
                vm.toast(`${vm.$t('payment.subscription_cancel_failed')}: ${err.message}`, 'error')
                vm.$emit('error')
            })

            if (vm.$refs.cancelModal) vm.$refs.cancelModal.hide()

            vm.toast(`${vm.$t('payment.subscription_cancel_successful')}`)
            vm.$emit('success')
            vm.loadingSubscribeCancel = false
        },
    }
}
</script>

<style scoped>

</style>